import { Hidden } from '@material-ui/core';
import { findLastIndex } from 'lodash-es';

const styles = (theme) => ({
  pageContainer: {
    marginTop: '70px',
    display: 'flex',
    width: '100%',
    [theme.breakpoints.up('md')]: {
      marginTop: '130px',
      marginLeft: '24px',
      marginRight: '24px',
    },
    [theme.breakpoints.up('xl')]: {
      marginLeft: 'auto',
      marginRight: 'auto',
      width: '1400px',
    },
  },
  contentWrapper: {
    width: '1125px',
  },
});

export default styles;
